real.events.on('widget:prompt:preview-generation:failed', function (notification) {
    const sourceWidget = $('.widget[data-widget-type="' + notification.object.source_widget.type + '"][data-widget-id="' + notification.object.source_widget.id + '"]');
    if (sourceWidget.length === 0) {
        return;
    }
    howspace.aiGen.clearPromptTimeout(sourceWidget)

    const previewModal = $('dialog[data-source-widget-type="' + notification.object.source_widget.type + '"][data-source-widget-id="' + notification.object.source_widget.id + '"]');
    const previewWrapper = previewModal.find('.widget-preview-wrapper');
    previewWrapper.text(notification.object.error);

    previewModal.find('.save-btn').prop('disabled', true).addClass('disabled');
    real.button.reset(sourceWidget.find('.generate-poll-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-pulse-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-priority-btn'), sourceWidget.find('.prompt-input-wrapper'));
    real.button.reset(sourceWidget.find('.generate-allocate-btn'), sourceWidget.find('.prompt-input-wrapper'));
});
